export const formatDate = val => {
  return val ? val.replace(/^(.{16})(.*)/g, '$1') : ''
}

export const formatPrice = val => {
  return val / 100
}

// export const formatDate = val => {
//   return val.substr(0, val.length - 3)
// }



// WEBPACK FOOTER //
// ./src/filter/index.js